export interface SegmentListResponse {
  page: number;
  pageSize: number;
  itemCount: number;
  list: SegmentListResponse.SegmentFolder[];
  response: null;
  item: null;
  Id: number;
}

export enum SegmentStatus {
  Complete = 0,
  Pending = 1
}

export namespace SegmentListResponse {
  export interface SegmentFolder {
    id: number;
    name?: string;
    items: Segment[];
  }

  export interface Segment {
    Segment_Action: any;
    count?: number;
    countio?: number;
    amount?: number;
    overdueAmount?: number;
    SegmentID: number;
    Created: string;
    CreatorUserID: number;
    Name: string;
    Include?: boolean;
    Error?: boolean;
    Hide: any;
    Calculated?: string;
    AlwaysVisible: boolean;
    SameIO: any;
    SegmentFolderID?: number;
    Sort?: number;
    Priority?: number;
    SegmentID_ref: any;
    Disabled: any;
    Criteria: any[];
    SegmentFolder: any;
    IsSuperSegment?: boolean;
    SuperSegmentID?: number | null;
    Status?: SegmentStatus | null;
  }
}
